/**
 * Portuguese formality linter for free-text fields (25/02/2026).
 *
 * O convenção Caring exige "Senhora Dona <nome>" no tratamento
 * formal de clientes idosas. Um utilizador que digite apenas
 * "Senhora Albertina" recebe uma sugestão suave para corrigir
 * antes de guardar. Preferimos alertar em vez de auto-corrigir
 * porque há casos legítimos ("uma senhora idosa" — não referindo
 * a cliente) que a auto-fix quebraria.
 *
 * Retorna uma lista de warnings — cada um com ``match`` (excerto
 * exacto) e ``suggestion``. Se o texto estiver ok, retorna [].
 */

// "Senhora" seguido de um nome próprio (letra maiúscula PT),
// SEM "Dona" a seguir. Ignora "Senhora Dona", "Senhoras" (plural),
// "Senhora idosa/nova/de idade" (sem nome próprio).
const SENHORA_MISSING_DONA = /\bSenhora\s+(?!Dona\b|dona\b|D\.\s|de\s|dos?\s|das?\s|com\s|que\s|é\s|do\s|da\s|para\s|não\s|nesta\s|neste\s|em\s|sua\s|nossa\s)([A-ZÁÉÍÓÚÂÊÔÃÕÇ][a-záéíóúâêôãõç]+)/g;

// "Sra." (abreviatura) seguido de nome próprio sem "D." ou "Dona"
const SRA_MISSING_DONA = /\bSra\.\s+(?!D\.\s|Dona\s|dona\s)([A-ZÁÉÍÓÚÂÊÔÃÕÇ][a-záéíóúâêôãõç]+)/g;

export function lintPortugueseFormality(text) {
  if (!text || typeof text !== "string") return [];
  const warnings = [];
  let m;

  SENHORA_MISSING_DONA.lastIndex = 0;
  while ((m = SENHORA_MISSING_DONA.exec(text)) !== null) {
    warnings.push({
      match: m[0],
      suggestion: `Senhora Dona ${m[1]}`,
      hint: `"${m[0]}" — a convenção Caring é "Senhora Dona ${m[1]}" no tratamento formal de clientes.`,
    });
  }

  SRA_MISSING_DONA.lastIndex = 0;
  while ((m = SRA_MISSING_DONA.exec(text)) !== null) {
    warnings.push({
      match: m[0],
      suggestion: `Sra. D. ${m[1]}`,
      hint: `"${m[0]}" — usa "Sra. D. ${m[1]}" (abreviatura formal) ou "Senhora Dona ${m[1]}".`,
    });
  }

  return warnings;
}

/**
 * Auto-corrige um texto substituindo todos os matches encontrados.
 * Não é chamado automaticamente — o operador clica no botão "Corrigir"
 * do banner de aviso.
 */
export function autofixPortugueseFormality(text) {
  if (!text) return text;
  return text
    .replace(SENHORA_MISSING_DONA, (m, name) => `Senhora Dona ${name}`)
    .replace(SRA_MISSING_DONA, (m, name) => `Sra. D. ${name}`);
}
